export default "__VITE_ASSET__eRf7DNU$__"